import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { V2ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { storage } from '@uhg-abyss/web/tools/storage';
import { V2Button } from '@uhg-abyss/web/ui/Button';
import { useUser } from '@src/state/user';
import { config } from '@uhg-abyss/web/tools/config';
import { Countdown } from '../../Countdown';
import { RESET_TIME, HAS_SIGNED_OUT } from '../constants';

export const IdleModal = ({
  events,
  timeRemaining,
  pingInterval,
  isOpen,
  closeModal,
}) => {
  const [originalExpiredTime, setOriginalExpiredTime] = useState();
  const { uuid } = useUser.state();
  const isSuperUser = storage.local.get(uuid);

  useEffect(() => {
    setOriginalExpiredTime(storage.local.get(RESET_TIME));
  }, [isOpen]);

  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    if (config('US3671382_SUPER_USER') && isSuperUser) {
      storage.local.remove(uuid);
    }

    events.onSignout();
  };

  const handleTimeout = () => {
    handleSignout();
  };

  const handleTick = (timeMS) => {
    if (originalExpiredTime !== storage.local.get(RESET_TIME)) {
      closeModal();
    }

    if (storage.local.get(HAS_SIGNED_OUT)) {
      events.onSignout();
    }
    const tickInterval = Math.floor((timeMS % pingInterval) / 1000);

    if (tickInterval === 0) {
      events.onIdleTick(timeMS);
    }
  };

  return (
    <V2ModalDialog
      size="600px"
      isOpen={isOpen}
      hideClose
      closeOnClickOutside={false}
      header="Session Timeout Warning"
    >
      <div>
        You will be signed out in a few minutes due to inactivity. All unsaved
        data on this page will be lost.
      </div>
      <div>
        Time remaining:{' '}
        <Countdown
          countdownMS={timeRemaining}
          onTick={handleTick}
          onComplete={handleTimeout}
        />
      </div>
      <Layout.Group alignLayout="right" css={{ marginTop: '24px' }}>
        <V2Button variant="outline" onClick={handleSignout}>
          Sign Out
        </V2Button>
        <V2Button onClick={closeModal}>Continue Working</V2Button>
      </Layout.Group>
    </V2ModalDialog>
  );
};

IdleModal.propTypes = {
  timeRemaining: PropTypes.number.isRequired,
  pingInterval: PropTypes.number.isRequired,
  events: PropTypes.shape({
    onIdleTimeout: PropTypes.func,
    setIdleRecovery: PropTypes.func,
    onIdleTick: PropTypes.func,
    onSignout: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
